export default __webpack_public_path__ + "static/media/hpv-screening.870e57bd.svg";